module.exports = "float random (in vec2 st) {\n   return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/chunks/random.raw.xml
// module id = XbjG
// module chunks = 1